/* eslint-disable new-cap */
/* eslint-disable react/no-find-dom-node */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import extend from 'lodash/extend';

const styles = {
  root: {
    position: 'relative',
  },
};

const itemTypes = {
  CARD: 'card',
};

/**
 * Implements the drag source contract.
 */
const cardSource = {
  beginDrag(props) {
    const { id } = props;
    if (props.onBeginDrag) {
      props.onBeginDrag(id);
    }
    return {
      id,
    };
  },
  endDrag(props, monitor) {
    if (props.onEndDrag) {
      const id = monitor.getItem().id;
      const dropResult = monitor.getDropResult();
      props.onEndDrag(id, dropResult);
    }
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    // WORKAROUND calculate position in case items have different heights
    const item = monitor.getItem();
    const dragIndex = item.index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.onMove(item.id, props.id);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    if (item) {
      item.index = hoverIndex;
    }
  },
};

/**
 * Specifies the props to inject into your component.
 */
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

/**
 * Specifies the props to inject into your component.
 */
function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

class DragDropSource extends Component {
  render() {
    const {
      style,
      children,
      handle,
      isDragging,
      connectDragSource,
      connectDragPreview,
      connectDropTarget,
    } = this.props;
    const opacity = isDragging ? 0 : 1;
    const containerStyle = extend(styles.root, style);

    return connectDragPreview(
      connectDropTarget(
        <div style={{ ...containerStyle, opacity }}>
          {children}
          {connectDragSource(handle)}
        </div>,
      ),
    );
  }
}

DragDropSource.propTypes = {
  children: PropTypes.node.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  handle: PropTypes.node,
  id: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onBeginDrag: PropTypes.func,
  onEndDrag: PropTypes.func,
  onMove: PropTypes.func,
  style: PropTypes.object,
};

export default DragSource(
  itemTypes.CARD,
  cardSource,
  collect,
)(DropTarget(itemTypes.CARD, cardTarget, collectTarget)(DragDropSource));
